/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/breadcrumbItem.config.json";

import { DEFAULT_APP_CONFIG } from "../../../config/default.config";

import { templateReplacer } from "../../../helpers/template.replace";

const is = require("is_js");
const parse = require("url-parse");

export interface IBreadcrumbItemMethods extends IPluginMethodMap {
  getBreadcrumbItemsSync(args: any): any;
}

export class BreadcrumbItemService implements IAgentPlugin {
  readonly methods: IBreadcrumbItemMethods;

  constructor() {
    this.methods = {
      getBreadcrumbItemsSync: this.getProps.bind(this),
    };
  }

  getProps(args: any) {
    let items: any = [];
    const _config: any = { ...(this.getTransformConfig(config) || {}) };
    const url = parse(window.location);
    const parsed: string[] = url?.pathname?.split("/");
    parsed?.forEach((parseItem: string) => {
      if (parseItem && is.not.empty(parseItem)) {
        if (_config[parseItem]) {
          items.push(_config[parseItem]);
        }
      }
    });
    return { breadcrumbItems: items };
  }

  private getTransformConfig(data: any) {
    const _transConfig = templateReplacer(JSON.stringify(data), {
      holder_name: DEFAULT_APP_CONFIG?.platformSemantics?.semantics?.holder,
      holders_name: DEFAULT_APP_CONFIG?.platformSemantics?.semantics?.holders,
      holder_group: DEFAULT_APP_CONFIG?.platformSemantics?.HoldersGroups?.title,
      credential: DEFAULT_APP_CONFIG?.platformSemantics?.semantics?.credential,
      credentials:
        DEFAULT_APP_CONFIG?.platformSemantics?.semantics?.credentials,
    });
    return JSON.parse(_transConfig);
  }
}
